import { useEffect, useState, useMemo } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaWhatsapp, FaInstagram } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { supabase } from "./supabase";
import { motion } from "framer-motion"; // 🎬 animasyon için
import React from "react";
import "./App.css";

// Daktilo efekti hook
// Daktilo efekti hook (güvenli sürüm)
function useTypewriter(rawText, speed = 100) {
  const text = String(rawText ?? ""); // null/undefined gelirse boş string
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    setDisplayed(""); // metin her değiştiğinde sıfırla
    let i = 0;
    let timer;

    const tick = () => {
      if (i < text.length) {
        setDisplayed((prev) => prev + text.charAt(i));
        i++;
        timer = setTimeout(tick, speed); // interval yerine zincirli timeout
      }
    };

    timer = setTimeout(tick, speed);
    return () => clearTimeout(timer);
  }, [text, speed]);

  return displayed;
}

export default function App() {
  // Aktif domain (www temizlenmiş)
  const currentDomain = useMemo(() => {
    const host = window.location.hostname || "";
    return host.replace(/^www\./i, ""); // sadece www kaldır
  }, []);

  const [sending, setSending] = useState(false);

  // Başlıkta gösterilecek domain
  const displayDomain = currentDomain || "domainalimsatim.com";

  // Domain listesi (Supabase)
  const [domains, setDomains] = useState([]);
  const [loadingDomains, setLoadingDomains] = useState(true);
  const [domainsError, setDomainsError] = useState(null);

  // Public klasöründeki arkaplanlar
  const backgrounds = ["/bg1.png", "/bg2.png", "/bg3.png"];
  const [randomBg] = useState(() => {
    const index = Math.floor(Math.random() * backgrounds.length);
    return backgrounds[index];
  });

  // Domainleri çek
  useEffect(() => {
    const fetchDomains = async () => {
      setLoadingDomains(true);
      setDomainsError(null);

      const { data, error } = await supabase
        .from("domains")
        .select("id, name, created_at")
        .order("created_at", { ascending: true });

      if (error) {
        console.error("Domainler alınamadı:", error);
        setDomainsError("Domain listesi yüklenemedi.");
        setDomains([]);
      } else {
        const cleaned = (data || []).filter((d) => {
          const n = (d?.name || "")
            .replace(/^https?:\/\//i, "")
            .replace(/^www\./i, "");
          return n && n.toLowerCase() !== currentDomain.toLowerCase();
        });
        setDomains(cleaned);
      }
      setLoadingDomains(false);
    };

    fetchDomains();
  }, [currentDomain]);

  // UI stilleri
  const glass = {
    background: "rgba(255,255,255,0.28)",
    border: "none",
    borderRadius: 16,
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
  };

  const lineInput = {
    background: "transparent",
    border: "none",
    borderBottom: "2px solid rgba(0,0,0,0.35)",
    borderRadius: 0,
    color: "#2c2c2c",
    boxShadow: "none",
    paddingLeft: 0,
    paddingRight: 0,
  };

  const socialBtn = (bg) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 52,
    height: 52,
    borderRadius: "50%",
    background: bg,
    color: "#fff",
    textDecoration: "none",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const f = new FormData(e.target);

    setSending(true); // ⏳ bekleme başlasın

    emailjs
      .send(
        "service_k4cnmww", // ✅ SMTP (Yandex) servis ID
        "template_ur4ilz9", // ✅ DOĞRU template ID
        {
          title: "Domain İletişim", // şablon Subject içinde {{title}} için
          name: f.get("name"), // {{name}}
          email: f.get("email"), // {{email}} (Reply To için)
          message: f.get("message"), // {{message}}
          domain: displayDomain, // şablona ekstra alan olarak yollanabilir
        },
        "CtSlWztCUIbaS2NmE" // ✅ senin EmailJS Public Key’in
      )

      .then(
        () => {
          alert("Mesaj başarıyla gönderildi ✅");
          e.target.reset();
        },
        (err) => {
          alert("Mesaj gönderilemedi ❌: " + err.text);
        }
      )
      .finally(() => {
        setSending(false); // ✅ her durumda bekleme bitsin
      });
  };

  const protocol = window.location.protocol || "https:";

  // Daktilo yazısı
  const typedText = useTypewriter(
    "Satışta. Teklif için iletişime geçiniz.",
    80
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        background: `url(${randomBg}) center/cover no-repeat`,
        color: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* HEADER */}
      <Container
        style={{
          textAlign: "center",
          paddingTop: window.innerWidth < 768 ? 40 : 20,
          paddingBottom: 30,
        }}
      >
        <motion.h1
          initial="hidden"
          animate={["visible", "floating"]}
          variants={{
            hidden: { opacity: 0, scale: 0.8 },
            visible: {
              opacity: 1,
              scale: 1,
              transition: { duration: 1, ease: "easeOut" }, // ilk giriş animasyonu
            },
            floating: {
              x: [0, 3, -3, 0, 2, -2, 0],
              y: [0, -2, 2, 0, -1, 1, 0],
              transition: {
                duration: 6, // hareket hızı
                ease: "easeInOut",
                repeat: Infinity, // sonsuz tekrar
              },
            },
          }}
          style={{
            fontWeight: 800,
            fontSize: window.innerWidth < 768 ? 28 : 52,
            margin: 0,
            textShadow: "0 3px 20px rgba(0,0,0,0.25)",
          }}
        >
          {displayDomain}
        </motion.h1>

        <div
          style={{
            fontWeight: 700,
            fontSize: window.innerWidth < 768 ? 16 : 28,
            marginTop: 6,
            textShadow: "0 2px 14px rgba(0,0,0,0.25)",
            minHeight: 40,
          }}
        >
          {typedText}
          <span style={{ opacity: typedText.length % 2 ? 1 : 0 }}>|</span>
        </div>
      </Container>

      {/* CONTENT */}
      <Container style={{ flex: 1 }}>
        <Row
          className="justify-content-center"
          style={{ alignItems: "flex-start" }}
        >
          {/* SOL: Form + sosyal */}
          <Col lg={5} md={6} className="mb-4">
            <Card style={glass} className="p-3">
              <Card.Body>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontWeight: 700 }}>
                      Ad Soyad
                    </Form.Label>
                    <Form.Control
                      name="name"
                      type="text"
                      required
                      style={lineInput}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontWeight: 700 }}>Mail</Form.Label>
                    <Form.Control
                      name="email"
                      type="email"
                      required
                      style={lineInput}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontWeight: 700 }}>Mesaj</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="message"
                      rows={2}
                      required
                      style={lineInput}
                    />
                  </Form.Group>

                  <div className="d-flex justify-content-between align-items-center">
                    <p
                      style={{
                        margin: 0,
                        fontSize: "0.8rem",
                        fontStyle: "italic",
                      }}
                    >
                      İletişime geçmek istediğiniz domaini mesaj alanına
                      yazınız.
                    </p>
                    <Button
                      type="submit"
                      disabled={sending} // beklerken tıklanamasın
                      style={{
                        background: sending ? "#ff6a00" : "#fff",
                        color: sending ? "#fff" : "#ff6a00",
                        border: "none",
                        fontWeight: 400,
                        letterSpacing: "0.12em",
                        padding: "8px 16px",
                        borderRadius: 18,
                        transition: "all 0.3s ease",
                      }}
                    >
                      {sending ? "Gönderiliyor..." : "GÖNDER"}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>

            <div className="d-flex gap-3 mt-3">
              <a
                href="https://wa.me/905325888019"
                target="_blank"
                rel="noreferrer"
                style={socialBtn("#25D366")}
              >
                <FaWhatsapp size={24} />
              </a>
              <a
                href="https://instagram.com/asalgrouptr"
                target="_blank"
                rel="noreferrer"
                style={socialBtn(
                  "radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%)"
                )}
              >
                <FaInstagram size={24} />
              </a>
            </div>
          </Col>

          {/* ORTA boşluk */}
          <Col lg={1} className="d-none d-lg-block" />

          {/* SAĞ: Domain listesi + Logo */}
          <Col
            lg={6}
            md={6}
            className="mb-4"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 20,
            }}
          >
            {/* Domain Kartı */}
            <div style={{ width: 360 }}>
              <Card style={glass} className="p-3">
                <Card.Body style={{ paddingBottom: 8 }}>
                  {/* Başlık kartın içinde */}
                  <h5
                    style={{
                      fontWeight: 500,
                      fontSize: 16,
                      marginBottom: 10,
                      textAlign: "left",
                      color: "rgba(0,0,0,0.9)",
                    }}
                  >
                    Satışta olan diğer alan adlarımıza göz atın;
                  </h5>

                  <div
                    className="scroll-box"
                    style={{
                      maxHeight: 176,
                      overflowY: "auto",
                      paddingRight: 4,
                    }}
                  >
                    {loadingDomains && (
                      <div style={{ color: "rgba(0,0,0,0.9)" }}>
                        Yükleniyor...
                      </div>
                    )}

                    {domainsError && (
                      <div style={{ color: "#c62828", fontWeight: 600 }}>
                        {domainsError}
                      </div>
                    )}

                    {!loadingDomains &&
                      !domainsError &&
                      domains.length === 0 && (
                        <div style={{ color: "rgba(0,0,0,0.75)" }}>
                          Gösterilecek başka domain yok.
                        </div>
                      )}

                    {!loadingDomains &&
                      !domainsError &&
                      domains.map((d, i) => {
                        const clean = (d.name || "")
                          .replace(/^https?:\/\//i, "")
                          .replace(/^www\./i, "");
                        return (
                          <div
                            key={d.id}
                            style={{
                              padding: "10px 0",
                              borderBottom:
                                i === domains.length - 1
                                  ? "none"
                                  : "1px solid rgba(0,0,0,0.1)",
                            }}
                          >
                            <a
                              href={`${protocol}//${clean}`}
                              target="_blank"
                              rel="noreferrer"
                              style={{
                                color: "rgba(0,0,0,0.9)",
                                textDecoration: "none",
                                fontWeight: 500,
                              }}
                            >
                              {clean}
                            </a>
                          </div>
                        );
                      })}
                  </div>
                </Card.Body>
              </Card>
            </div>

            {/* Logo */}
            <div style={{ width: 360 }}>
              <img
                src="/logo.png"
                alt="ASAL"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
